import { useEffect, useState, type ReactNode } from "react";

/**
 * Collapsible block used by the Variants and States panels to tuck a labeled
 * subset of options (e.g. an "Archive") under one header.
 */
export const AccordionSection: React.FC<{
  label: string;
  children: ReactNode;
  defaultOpen?: boolean;
}> = ({ label, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  useEffect(() => {
    if (defaultOpen) {
      setIsOpen(true);
    }
  }, [defaultOpen]);

  return (
    <div className="rounded-lg border border-[#2a2a2a]">
      <button
        type="button"
        onClick={() => setIsOpen((current) => !current)}
        className="flex w-full items-center justify-between gap-2 px-2.5 py-2 text-left"
      >
        <span className="text-[10px] font-medium tracking-wide text-[#aaa] uppercase">
          {label}
        </span>
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          className={`shrink-0 text-[#888] transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
          aria-hidden
        >
          <path
            d="M3 4.5L6 7.5L9 4.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {isOpen ? (
        <div className="space-y-3 px-2.5 pt-0 pb-2.5">{children}</div>
      ) : null}
    </div>
  );
};
